require('venuescanner-js/react/components/Inbox')
